function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.67706 16.9688L13.7187 12.9271L9.67706 8.88542C9.27081 8.47917 9.27081 7.82292 9.67706 7.41667C10.0833 7.01042 10.7396 7.01042 11.1458 7.41667L15.9271 12.1979C16.3333 12.6042 16.3333 13.2604 15.9271 13.6667L11.1458 18.4479C10.7396 18.8542 10.0833 18.8542 9.67706 18.4479C9.28123 18.0417 9.27081 17.375 9.67706 16.9688Z",
  fill: "white"
});
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.0b1345d8a9e4d60830fb144ae55d03f1.svg";
export { ForwardRef as ReactComponent };